/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_StageInputs */



/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Nav_StageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_stage = /** @type {((inputs?: Nav_StageInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_StageInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bühne")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scène")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("展示台")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("展示台")
	if (locale === "ko") return /** @type {LocalizedString} */ ("스테이지")
	return /** @type {LocalizedString} */ ("Stage")
});